module.exports = __webpack_public_path__ + "static/media/overlay@2x.16678413.png";